export default "__VITE_ASSET__2nEwz399__"